let isDragging = false;

export const DocgenDragEvent = {
	setIsDragging(value) {
		isDragging = value;
	},
	isDragging() {
		return isDragging;
	},
	clear() {
		isDragging = false;
	},
};
